import { makeStyles, TextField, TextFieldProps} from "@material-ui/core";
import { v4 } from 'uuid';

const useStyles = makeStyles((theme: any) => ({
    form: {
        marginBottom: 10,
    },
    label: {
        background: "white !important",
    },  
    textFieldContainer: {
        borderColor: '#666666'
    }
}));

export type CustomTextFieldProps = {
  } & TextFieldProps;

export const InputField: React.FC<CustomTextFieldProps> = ({ ...props }) => {
    const classes = useStyles()

    return (
        <TextField
        className={classes.textFieldContainer} 
        {...props} />
    )
}